import React from 'react'
import PropTypes from 'prop-types'
import { currencyForInput, decimalFormat, normalizeCurrencyString } from 'utils/format'
import { Input } from 'ui-components/Input'
import set from 'utils/set'

export default function InputCurrency(props) {
  const {
    name,
    label,
    value,
    onChange,
    max,
    min,
  } = props

  const validRange = (val) => {
    const currency = Number(val)
    if (typeof min === 'number' && currency < min) {
      return false
    }

    if (typeof max === 'number' && currency > max) {
      return false
    }

    return true
  }

  const handleChange = (evt) => {
    const { value: val } = evt.target
    const decimalValue = currencyForInput(val.length ? val : '0')
    const currency = decimalFormat(decimalValue)

    if (!validRange(currency)) return
    const event = set({
      object: evt,
      field: 'target.value',
      value: currency,
    })

    onChange(event)
  }

  return (
    <Input
      label={label}
      name={name}
      value={currencyForInput(normalizeCurrencyString(value))}
      onChange={handleChange}
    />
  )
}

InputCurrency.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  onChange: PropTypes.func.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
}

InputCurrency.defaultProps = {
  value: '',
  max: null,
  min: null,
}
